import axios from 'axios'

export default {
    initialize: function () {
        window.ptId = getPtId();
        window.clientId = parseInt(getParamValue('client_id'))
        window.language = getLanguage()
        window.apiDev = getParamValue('dev')
        window.apiKey = getApiKey()
        window.webviewConfig = getWebviewConfig()
        setIndexProperties()

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (window.PTS_IDS && window.PTS_IDS[pt]) {
                    return window.PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag) {
                    return ptTag.id
                }
            }
            return ptId
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            }
            return 'pt'
        }

        function getApiKey() {
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function getWebviewConfig() {
            if (window.PTS_TAGS) {
                const ptTag = window.PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag && ptTag.webview) {
                    return ptTag.webview
                }
            }
            return null
        }

        function setIndexProperties() {
            if (window.webviewConfig) {
                if (window.webviewConfig.title) {
                    document.title = window.webviewConfig.title
                }
                if (window.webviewConfig.icon) {
                    document.querySelector("link[rel='shortcut icon']").href = window.webviewConfig.icon
                }
            }
        }
    },
    updateAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        axios.defaults.authorization = 'Basic ' + window.btoa(user + ':' + password)
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }

            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(error),
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }

        return messageError
    },
    getAlertOptions: function (texts) {
        const str = window.strings ? window.strings : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        return {
            confirmButtonText: texts && texts.confirm ? texts.confirm : str['ok'],
            cancelButtonText: texts && texts.cancel ? texts.cancel : str['cancel']
        }
    },
    encodeEmail: function (email) {
        return email.toLowerCase().replace(/ /g, '')
    },
    refreshAppUrl: function (config) {
        if ((config && config.dev) || window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
        }
    },
}
